import { render, staticRenderFns } from "./ordem.vue?vue&type=template&id=97ef477a"
import script from "./ordem.vue?vue&type=script&lang=js"
export * from "./ordem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports